
import PropTypes from 'prop-types'

const propTypes = {
  message: PropTypes.string,
}

export default function MessageContainer({ message }) {
  return <div className='h-18 flex items-center justify-center text-center twy-text-base-accent'>{message}</div>
}

MessageContainer.propTypes = propTypes
MessageContainer.defaultProps = {}
